var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSideBySideLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.203v1.04a.443.443 0 0 1-.438.444H4.439c-.241 0-.438-.2-.438-.445v-1.039c0-.245.197-.445.438-.445h6.125c.24 0 .437.2.437.445zm-.438 2.672H4.439c-.241 0-.438.2-.438.445v1.04c0 .244.197.445.438.445h6.125c.24 0 .437-.2.437-.446V17.32a.443.443 0 0 0-.438-.445zm3.938-6.98v12.324c0 .983-.784 1.781-1.75 1.781H2.25C1.284 24 .5 23.202.5 22.219V6.78C.5 5.798 1.284 5 2.25 5h7.441c.463 0 .908.19 1.236.523l3.059 3.114c.328.33.514.786.514 1.258zM9.25 5.792v4.354h4.278L9.25 5.792zm4.083 16.823V11.379H9.12c-.538 0-.972-.417-.972-.936V6.385H1.667v16.23h11.666zM26 14.203v1.04a.443.443 0 0 1-.438.444h-6.125c-.24 0-.437-.2-.437-.445v-1.039c0-.245.197-.445.438-.445h6.125c.24 0 .437.2.437.445zm-.438 2.672h-6.125c-.24 0-.437.2-.437.445v1.04c0 .244.197.445.438.445h6.125c.24 0 .437-.2.437-.446V17.32a.443.443 0 0 0-.438-.445zm3.938-6.98v12.324c0 .983-.784 1.781-1.75 1.781h-10.5c-.966 0-1.75-.798-1.75-1.781V6.78c0-.983.784-1.781 1.75-1.781h7.441c.463 0 .908.19 1.236.523l3.059 3.114c.328.33.514.786.514 1.258zm-5.25-4.103v4.354h4.278L24.25 5.792zm4.083 16.823V11.379H24.12c-.538 0-.972-.417-.972-.936V6.385h-6.481v16.23h11.666z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSideBySideLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-side-by-side-light.7684201cd2c0c825183ee6c417fc7e4a.svg";